import type { NitroFetchOptions } from "nitropack"
export default defineNuxtPlugin({
    name: 'fetchInterceptor',
    enforce: 'pre',
    setup(nuxtApp) {
        nuxtApp.provide('fetch', async <T> (url: string, opts: NitroFetchOptions<'json', 'post'|'get'>): Promise<{ statusCode: keyof typeof CodeMessage, data: T, message: string }> => {
            let request = []
            let response = []
            if (opts.onRequest) {
                request.push(...(Array.isArray(opts.onRequest)? opts.onRequest: [opts.onRequest]));
            }
            if (opts.onResponse) {
                response.push(...(Array.isArray(opts.onResponse)? opts.onResponse: [opts.onResponse]));
            }
            delete opts.onRequest
            delete opts.onResponse

            const options: NitroFetchOptions<'json', 'post'|'get'> = {
                method: 'post',
                responseType: 'json',
                retry: 3,
                retryDelay: 500, // ms
                timeout: 60000,
                credentials: 'include',
                onRequest: [
                    (config) => {
                        console.log(config)
                    },
                    ...request
                ],
                onResponse: [
                    async ({ response }) => {
                        if (response.status === 401) {
                            await navigateTo('/login', {
                                external: true
                            })
                        }
                    },
                    ...response
                ],
                ...opts
            }

            return $fetch<{ statusCode: keyof typeof CodeMessage, data: T, message: string }>(url, options)
        })
    }
})